export default __webpack_public_path__ + "static/media/buzzer.bb5b194d.svg";